import { appBaseUrl } from "@/variables"

import { AccountClient } from "@/lib/api"


const initialState = () => ({
    api: new AccountClient(appBaseUrl),
    customerInfo: JSON.parse(window.localStorage.getItem('customerInfo')) || {},
    isRegistered:  JSON.parse(window.localStorage.getItem('isRegistered')) || false,
    language : window.localStorage.getItem('language') || "ar"
});

// State object
const state = {
    api: new AccountClient(appBaseUrl),
    customerInfo: JSON.parse(window.localStorage.getItem('customerInfo')) || {},
    isRegistered:  JSON.parse(window.localStorage.getItem('isRegistered')) || false,
    language: window.localStorage.getItem('language') || "ar"
}

// Getter functions
const getters = {
    getApi(state) {
        return state.api;
    },
    customerInfo(state) {
        return state.customerInfo;
    },
    isRegistered(state) {
        return state.isRegistered;
    },
    language(state) {
        return state.language;
    },
    isLoggedIn(){
        let token = window.localStorage.getItem('token') || ""
        return token !== "";
    }
}

// Actions 
const actions = {

   async signUp({commit, state}, {name, phone, email, password}){

        let model = {
            name : name,
            phone: phone,
            email: email,
            password: password,
            countryCode: 'KW',
            language : state.language
        }

        //response = Bearer Token
        const response = await state.api.signUp(model);

        commit('signUpCompleted', response);
    },
    
    async logIn({commit, state}, {userName, password}){

        let model = {
            userName : userName,
            password: password,
            language : state.language
        }

        //response = Bearer Token
        const response = await state.api.logIn(model);

        commit('logInCompleted', response); 
    },

    async signUpAnonymous({commit, state}){

        //response = Bearer Token
        const response = await state.api.signUpAnonymous();

        commit('signUpCompleted', response);
    },

    async changePassword({state},  {currentPassword, newPassword}){

        let model = {
            currentPassword : currentPassword,
            newPassword: newPassword,
            language : state.language
        }

        await state.api.changePassword(model);

        //commit('signUpCompleted', response);

    },

    async forgotPassword({state},  email){

        await state.api.forgotPassword(email, state.language);

    },

    async updateCustomerInfo({commit,state},  {name, phone}){

        let model = {
            name : name,
            phone: phone,
            language : state.language
        }
        
        await state.api.updateCustomerInfo(model);

        commit('updateCustomerInfoCompleted', model);
    },

    async loadCustomerInfo({commit,state}){

        const response = await state.api.customerInfo();

        commit('loadCustomerInfoCompleted', response);

    },

    async confirmResetPassword({state}, {userId, token, password}){

        let model = {
            userId : userId,
            token: token,
            password: password,
            language : state.language
        }

        await state.api.confirmReset(model);

    },
    changeLanguage({commit,state}, language){
        state.language = language;
        commit('changeLanguageCompleted', language);
    },

    logOut({commit}){

        commit('logOutCompleted');
    }

}

// Mutations
const mutations = {

    signUpCompleted(state, bearerToken){
        
        window.localStorage.setItem('token', bearerToken.token);
        window.localStorage.setItem('isRegistered', bearerToken.isRegistered);
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer ${bearerToken.token}`};
        state.isRegistered = bearerToken.isRegistered;
    },

    logInCompleted(state, bearerToken){
        //console.log('signUpCompleted');
        window.localStorage.setItem('token', bearerToken.token);
        window.localStorage.setItem('isRegistered', bearerToken.isRegistered);
        //console.log(`logInCompleted token:${bearerToken.token}`);
        //console.log('signUpCompleted - token');
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer ${bearerToken.token}`};
        state.isRegistered = bearerToken.isRegistered;
    },

    updateCustomerInfoCompleted(state, customerInfo){
        state.customerInfo.name = customerInfo.name;
        state.customerInfo.phone = customerInfo.phone;
        window.localStorage.setItem('customerInfo',  JSON.stringify(customerInfo));
    },

    loadCustomerInfoCompleted(state, customerInfo){
        state.customerInfo = customerInfo;
        window.localStorage.setItem('customerInfo',  JSON.stringify(customerInfo));
    },

    changeLanguageCompleted(state, language){
        window.localStorage.setItem('language',  language);
    },

    logOutCompleted(state){
        window.localStorage.clear();
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer 1`};
    },

    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
    loadToken(state){
        let token = window.localStorage.getItem('token') || ""
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer ${token}`};
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}